import { type DrawDefinition, type Entry } from '@clubspark-node/clubspark-tennis-types';
import { type TFunction } from 'i18next';

export const getFlightDisabledInfo = ({
  isRemoving,
  t,
  drawDefinition,
  drawEntries,
  selectedIds,
}: {
  isRemoving: boolean;
  t: TFunction;
  drawDefinition: DrawDefinition;
  drawEntries: Entry[];
  selectedIds: string[];
}): { isDisabled: boolean; drawLabelInfo: string } => {
  const selectedPlayersCount = selectedIds?.length;

  if (drawDefinition)
    return {
      isDisabled: true,
      drawLabelInfo: t('splitDraws.participantsPerFlightDisabled', { count: drawEntries.length }),
    };

  if (isRemoving) {
    if (selectedPlayersCount === 1 && !drawEntries.some((entry) => entry.participantId === selectedIds[0]))
      return {
        isDisabled: true,
        drawLabelInfo: t('splitDraws.playerNotInDraw'),
      };
    return { isDisabled: false, drawLabelInfo: t('splitDraws.participantsPerFlight', { count: drawEntries.length }) };
  } else {
    if (selectedPlayersCount === 1 && drawEntries.some((entry) => entry.participantId === selectedIds[0]))
      return {
        isDisabled: true,
        drawLabelInfo: t('splitDraws.playerAlreadyInDraw', { count: drawEntries.length }),
      };

    if (
      selectedIds.every(
        (selectedParticipantId) =>
          drawEntries.map((entry) => entry.participantId).indexOf(selectedParticipantId) !== -1,
      )
    )
      return {
        isDisabled: true,
        drawLabelInfo: t('splitDraws.playersAlreadyInDraw', { count: drawEntries.length }),
      };

    return { isDisabled: false, drawLabelInfo: t('splitDraws.participantsPerFlight', { count: drawEntries.length }) };
  }
};
